import React from 'react';
import { Link } from 'react-router-dom';
import dailyFlowers from '../data/dailyFlowers';

export default function DailyFlowers() {
  return (
    <section className="py-12">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h3 className="text-3xl font-extrabold tracking-tight">Daily Fresh Flowers</h3>
          <p className="text-[#9a8d4c] font-medium">Loose blossoms for your daily rituals and décor</p>
        </div>
        <Link
          to="/products"
          className="flex items-center gap-1 font-bold text-primary hover:text-gold-dark transition-colors"
        >
          View All
          <span className="material-symbols-outlined">chevron_right</span>
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
        {dailyFlowers.map((f) => (
          <div key={f.id} className="bg-white rounded-2xl border border-[#e7e3cf] overflow-hidden hover:shadow-lg transition-shadow group">
            <div className="aspect-square relative overflow-hidden">
              <img alt={f.alt} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-110" src={f.img} />
              {f.badge && (
                <div className="absolute bottom-2 left-2 bg-red-500 text-white text-[10px] px-2 py-1 rounded font-bold">{f.badge}</div>
              )}
              <button className="absolute top-3 right-3 p-2 bg-white/90 rounded-full text-red-500 hover:bg-red-500 hover:text-white transition-all shadow-sm">
                <span className="material-symbols-outlined !text-xl">favorite</span>
              </button>
            </div>
            <div className="p-4">
              <h4 className="font-bold text-gray-800">{f.title}</h4>
              <p className="text-xs text-[#9a8d4c] mb-3">{f.unit}</p>
              <div className="flex items-center justify-between">
                <div className="flex flex-col">
                  <span className="text-[10px] text-[#9a8d4c] line-through font-medium">{f.oldPrice}</span>
                  <span className="text-lg font-extrabold text-primary">{f.price}</span>
                </div>
                <button className="bg-[#f3f1e7] p-2 rounded-lg hover:bg-primary hover:text-white transition-colors">
                  <span className="material-symbols-outlined !text-xl">add_shopping_cart</span>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
